import React from 'react';
import IconButton from '../../../icon-button';
import DialogHeaderControl from '../dialog-header-control';
import { APPEARANCES, SIZES } from '../../../icon-button/constants';
const DialogHeaderIconButton = (props) => (
  <DialogHeaderControl>
    <IconButton {...props} appearance={APPEARANCES.light} transparent size={SIZES.medium} />
  </DialogHeaderControl>
);

export default DialogHeaderIconButton;
